import { Component, DestroyRef } from '@angular/core';
import { Template, TemplateFilters } from 'src/app/components/company/models/new/template';
import { MutationQuery } from 'src/app/shared/types/mutation-query.enum';
import { AppService } from 'src/app/app.service';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { TemplatesQueries } from 'src/app/shared/types/get-query';
import { TemplateMapper } from '../../services/template-mapper';
import { map } from 'rxjs';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { FilterListComponent } from 'src/app/shared/components/filter-list/filter-list.component';
import { Brand } from '../../models/new/brand.model';
import { Category } from '../../models/new/category';
import { StyleGroup } from '../../models/new/style-group';
import { Team } from '../../models/new/team';
import { TeamFilterService } from 'src/app/services/filters/team-filter.service';
import { StyleGroupFilterService } from 'src/app/services/filters/style-group-filter.service';
import { CategoryFilterService } from 'src/app/services/filters/category-filter.service';
import { BrandFilterService } from 'src/app/services/filters/brand-filter.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import { Paginable } from 'src/app/shared/types/paginable';
import { Selectable } from 'src/app/shared/types/selectable.type';

@Component({
	standalone: false,
	selector: 'bt-company-template-list',
	templateUrl: './company-template-list.component.html',
	styleUrls: ['./company-template-list.component.scss']
})
export class CompanyTemplateListComponent {
	templates: Paginable<Selectable<Template>> = new Paginable<Selectable<Template>>();
	templateFilters: TemplateFilters = new TemplateFilters();
	loading = false;
	constructor(
		private graphQLService: GraphQLService,
		private appService: AppService,
		private utilitiesService: UtilitiesService,
		private templateMapper: TemplateMapper,
		private dialog: MatDialog,
		private brandFilterService: BrandFilterService,
		private categoryFilterService: CategoryFilterService,
		private styleGroupFilterService: StyleGroupFilterService,
		private teamFilterService: TeamFilterService,
		private router: Router,
		private route: ActivatedRoute
	) {}

	ngOnInit() {
		this.getTemplates();
	}

	getSelectedTemplates(): Template[] {
		return this.templates.items.filter((template) => template.selected);
	}

	selectTemplate(template: Selectable<Template>) {
		template.selected = !template.selected;
	}

	toggleSelectAll() {
		//seleziona solo i status diversi da shooting
		const allSelected = this.getSelectedTemplates().length === this.templates.items.length;
		this.templates.items.forEach((template) => {
			template.selected = !allSelected;
		});
	}

	pageEvent(event: { pageNumber: number; pageSize: number }) {
		this.templates.currentPage = event.pageNumber;
		this.templates.size = event.pageSize;

		this.templateFilters.page = event.pageNumber;
		this.templateFilters.size = event.pageSize;

		this.refreshNavigation();
	}

	refreshNavigation() {
		this.loading = true;

		this.router.navigate([location.pathname], {
			queryParams: this.templateMapper.filtersToUrl(this.templateFilters)
		});
	}

	prepareFilterOptions(params: Params) {
		//questi chiamate servono per popolare il nome delle tendine di parametri in input tramite url

		if (params['brands'] && params['brands'].length) {
			this.brandFilterService.searchById(params['brands']).subscribe((res: Brand[]) => {
				this.templateFilters.brands?.forEach((brand) => {
					const found = res.find((b) => b.id == brand.id);
					console.log(brand);
					brand.name = found ? found.name : '';
				});
			});
		}

		if (params['categories'] && params['categories'].length) {
			this.categoryFilterService.searchById(params['categories']).subscribe((res: Category[]) => {
				this.templateFilters.categories?.forEach((category) => {
					const found = res.find((c) => c.id == category.id);
					category.name = found ? found.name : '';
				});
			});
		}

		if (params['styleGroups'] && params['styleGroups'].length) {
			this.styleGroupFilterService.searchById(params['styleGroups']).subscribe((res: StyleGroup[]) => {
				this.templateFilters.styleGroups?.forEach((styleGroup) => {
					const found = res.find((sg) => sg.id == styleGroup.id);
					styleGroup.name = found ? found.name : '';
				});
			});
		}

		if (params['teams'] && params['teams'].length) {
			this.teamFilterService.searchById(params['teams']).subscribe((res: Team[]) => {
				this.templateFilters.teams?.forEach((team) => {
					const found = res.find((t) => t.id == team.id);
					team.name = found ? found.name : '';
				});
			});
		}
	}

	getTemplates() {
		this.loading = true;

		this.route.queryParams.subscribe((params: Params) => {
			this.templateFilters = this.templateMapper.urlToFilters(params);

			this.templates.currentPage = this.templateFilters.page || 1;
			this.templates.size = this.templateFilters.size || 2;

			//metodo che popola le label dei filtri in base agli id passati da url,
			this.prepareFilterOptions(params);

			const pagination = this.templates.buildQuery(this.templates.currentPage);
			console.log('Fetching templates with filters', this.templateFilters, 'and pagination', pagination);
			this.graphQLService
				.getData<any>(TemplatesQueries.GET_TEMPLATES, { where: this.templateMapper.toWhereClause(this.templateFilters), ...pagination })
				.pipe(
					map((res: any) => {
						const templates = res.data.templates;

						const paginable = new Paginable<Selectable<Template>>({
							items: templates.nodes.map((node: any) => ({
								...this.templateMapper.toTemplate(node),
								selected: false
							})),
							totalCount: templates.totalCount,
							currentPage: this.templates.currentPage,
							size: this.templates.size
						});

						return paginable;
					})
				)
				.subscribe({
					next: (data: Paginable<Selectable<Template>>) => {
						this.templates = data;
						this.loading = false;
					},
					error: (err: any) => {
						console.error('Error loading templates', err);
						this.utilitiesService.showSnackbar('Error loading templates', SnackbarType.Error);
						this.loading = false;
					}
				});
		});
	}

	cleanFilter(filter: string) {
		switch (filter) {
			case 'brands':
				this.templateFilters.brands = [];
				break;
			case 'categories':
				this.templateFilters.categories = [];
				break;

			case 'styleGroups':
				this.templateFilters.styleGroups = [];
				break;

			case 'teams':
				this.templateFilters.teams = [];
				break;

			default:
				break;
		}

		//se si pulisce un filtro, porta a pagina 1
		this.templateFilters.page = 1;

		this.refreshNavigation();
	}

	openBrandFilterModal(): void {
		this.dialog
			.open(FilterListComponent<Brand>, {
				data: {
					title: 'Brands',
					selected: this.templateFilters.brands
						? this.templateFilters.brands.map((el) => ({
								...el,
								displayId: el.id,
								displayName: el.name,
								selected: true
							}))
						: [],
					filterService: this.brandFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Brand>>) => {
					if (res) {
						this.templateFilters.brands = res.map((el: any) => new Brand({ id: el.displayId, name: el.displayName }));

						this.refreshNavigation();
					}
				}
			});
	}

	openCategoryFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Categories',
					selected:
						this.templateFilters.categories?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.categoryFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Category>>) => {
					if (res) {
						this.templateFilters.categories = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.refreshNavigation();
					}
				}
			});
	}

	openStyleGroupFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Style Groups',
					selected:
						this.templateFilters.styleGroups?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.styleGroupFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<StyleGroup>>) => {
					if (res) {
						this.templateFilters.styleGroups = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.refreshNavigation();
					}
				}
			});
	}

	openTeamFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Teams',
					selected:
						this.templateFilters.teams?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.teamFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Team>>) => {
					if (res) {
						this.templateFilters.teams = res.map((el: any) => ({ id: el.displayId, name: el.displayName, code: el.code }));
						this.refreshNavigation();
					}
				}
			});
	}

	removeTemplate(template: Selectable<Template>) {
		this.dialog
			.open(ConfirmModalComponent, {
				data: {
					title: 'Remove Template',
					message: 'Are you sure you want to remove this template?'
				}
			})
			.afterClosed()
			.subscribe((confirm: boolean) => {
				if (confirm) {
					const variables = {
						parentTemplateId: template.id
					};
					this.graphQLService.postData(MutationQuery.DELETE_TEMPLATE, { deleteTemplateInput: variables }).subscribe({
						next: () => {
							this.utilitiesService.showSnackbar('Template removed successfully', SnackbarType.Success);
							this.getTemplates();
						},
						error: () => {
							this.utilitiesService.showSnackbar('Error removing template', SnackbarType.Error);
						}
					});
				}
			});
	}

	/*deleteTemplate() {
		const variables = { 
			parentTemplateId: 0, //this.templates.tmp.templateId,
			currentUserId: this.appService.user.userId
		};
		this.graphQLService
			.postData(MutationQuery.DELETE_TEMPLATE, variables)

			.subscribe({
				next: () => {},
				error: () => {
					this.utilitiesService.showSnackbar('Missing fields to save template');
				}
			});
	}*/

	/*onSaveTemplate(template?: Template) {
		const updateTemplate: UpdateTemplate = {
			templateId: template?.id,
			brandId: template?.brandId,
			categoryId: template?.categoryId || undefined,
			modelIds: template?.styles.map((s) => new Ids(s.modelId)) || [],
			//colorIds: template?.colors.map((s) => new Ids(s.id)) || [],
			shotTypes: template?.shotTypes.map((type, index) => {
				return {
					shotTypeId: type.shotTypeId || undefined,
					shotTypeName: type.shotTypeName || '',
					shotTypeCode: type.shotTypeCode,
					sizeGroupId: type.sizeGroupId,
					aspectRatioId: type.aspectRatioId,
					mediaFormatId: type.mediaFormatId,
					codifiedUsedId: type.codifiedUsedId,
					ord: index + 1
				} as TemplateShotTypeDTI;
			})
		};
		this.graphQLService
			.postData(MutationQuery.UPDATE_TEMPLATE, { updateTemplate,  currentUserId: this.appService.user.userId })

			.subscribe(() => {});
	}*/

	// Getter
	/*


	private getSizeGroups(brandId: number) {
		this.#graphQLService
			.getData(SharedQueries.GET_SIZE_GROUPS_BY_BRAND, { brandId })
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res: any) => res['data']['sizeGroupsByBrand'])
			)
			.subscribe((data: WrapperResultGraphQL<any>) => {
				this.sizeGroups.disabledDeleteAction = false;
				this.sizeGroups.data = UtilityFunctions.DeepClone(data.nodes);
				!this.templates.tmp?.templateId
					? this.sizeGroups.data.forEach((s) => {
							s.disabled = true;
							this.templates.tmp!.shotTypes.push({
								shotTypeId: undefined,
								shotTypeName: undefined,
								sizeGroupId: s.id,
								sizeGroupName: s.name,
								sizeIndex: 0
							} as TemplateShotType);
						})
					: this.setSizeGroupsBooleans();
			});
	}

	private getShotTypes() {
		const filter = {
			first: this.shotTypes.size,
			after: this.shotTypes.pageInfo.endCursor,
			search: this.shotTypes.search
		};

		this.#graphQLService
			.getData<ShotType>(TemplatesQueries.GET_SHOT_TYPES, filter)
			.pipe(
				map((res) => res['data']['shotTypes']),
				takeUntilDestroyed(this.#destroyRef)
			)
			.subscribe({
				next: (data: WrapperResultGraphQL<ShotType>) => {
					this.shotTypes.data = !this.colors.pageInfo.endCursor
						? UtilityFunctions.DeepClone(data.nodes)
						: this.shotTypes.data.concat(UtilityFunctions.DeepClone(data.nodes));
					this.colors.pageInfo = { ...data.pageInfo };
				}
			});
	}
	

	private getMediaTypes(page: number) {
		this.mediaTypes.page = page;
		this.#graphQLService
			.getData<MediaFormat>(TemplatesQueries.GET_MEDIA_FORMATS)
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res: any) => res['data']['mediaFormats'])
			)
			.subscribe((data: WrapperResultGraphQL<MediaFormat>) => {
				this.mediaTypes.data = !this.mediaTypes.page
					? UtilityFunctions.DeepClone(data.nodes)
					: this.mediaTypes.data.concat(UtilityFunctions.DeepClone(data.nodes));
			});
	}
  
	// Codified Used
	private getCodifiedUsed(page: number) {
		this.codifiedUseds.page = page;

		this.#graphQLService
			.getData<CodifiedUsed>(TemplatesQueries.GET_CODIFIED_USEDS, {
				search: this.codifiedUseds.search,
				first: this.codifiedUseds.size,
				after: this.codifiedUseds.pageInfo.endCursor
			})
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res: any) => res['data']['codifiedUseds'])
			)
			.subscribe((data: WrapperResultGraphQL<CodifiedUsed>) => {
				this.codifiedUseds.data = !this.codifiedUseds.pageInfo.endCursor
					? UtilityFunctions.DeepClone(data.nodes)
					: this.codifiedUseds.data.concat(UtilityFunctions.DeepClone(data.nodes));
				this.codifiedUseds.pageInfo = UtilityFunctions.DeepClone(data.pageInfo);
			});
	}*/
}
